import React, { Component } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import dp from '../assets/dp.jpg'
// import './temp.css'

export class Loading extends Component {
    render() {
        return (
            <div style={{margin:'12px auto',width:'50%'}}>
                <img src = {dp} className='loadingTemp' alt='load'/>
            </div>
        )
    }
}

export default Loading
